import { configuratorActions } from './configurator-slice';
import config from './config';
import { getCsrfToken } from './config';
import { getSourceCode } from './config';
import moment from "moment";

export const fetchConfiguratorData = (defaultConfiguratorState) => {
  return async (dispatch) => {
    const fetchData = async () => {
      let url = config.settings.apiEndpoint + 'api/requests/GetEnrollmentCardDefaults/' + config.settings.skuId;
      if(config.settings.cartItemId) {
        url = config.settings.apiEndpoint + 'api/requests/GetEnrollmentCardDefaults/' + config.settings.skuId + '/' + config.settings.cartItemId;
      }
      const csrfToken = getCsrfToken();
      const response = await fetch(
        url,
        {
          method: 'GET',
          credentials: "include",
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': csrfToken
          }
        }
      );

      if (!response.ok) {
        throw new Error('Could not fetch configurator data!');
      }

      const data = await response.json();

      return data;
    };

    try {
      const configuratorData = await fetchData();
      //console.log('configurator data loaded');
      dispatch(
        configuratorActions.setInitialState({
            pageDefaults: defaultConfiguratorState,
            request: configuratorData
        })
      );
    } catch (error) {
      console.log(error);
      alert(error);
    }
  };
};

export const sendCartData = (currentCart, currentPreview, currentProduct) => {

  let cardSendItem = {
    Id: currentCart.Id,
    SkuId: currentProduct.SKUID,
    Quantity: 1,
    Price: (currentCart.OfferingAmount) ? parseFloat(currentCart.OfferingAmount) : 0,
    CustomData: []
  };
  if(currentCart.Id) {
    cardSendItem.Id = Number(currentCart.Id);
  }

  // set donor request fields related to cart
  currentCart.ProductID = currentProduct.SKUID;
  currentCart.CurrentProductID = currentProduct.SKUID;
  currentCart.CurrentProduct = currentProduct.SKUNumber;
  currentCart.OccasionLabel = currentPreview.Occasion.Description;
  currentCart.Purpose = currentPreview.Occasion.PortfolioPurposeCode;
  currentCart.CurrentPurpose = currentPreview.Occasion.PortfolioPurposeCode;  
  currentCart.Card = currentPreview.SelectedCard.PictureCode; //PortfolioPictureCode
  currentCart.CardID = currentPreview.SelectedCard.Id;
  currentCart.CardDescription = currentPreview.SelectedCard.Description;
  currentCart.CardImage = currentPreview.SelectedCard.CoverImage; //CoverImage

  if(currentCart.MailDate) currentCart.MailDate = moment(currentCart.MailDate).format('L');

  // ecard info
  if(currentCart.CardTypeValue === 'ecard') {
    const ecardData = {
        CoverImage: currentPreview.SelectedCard.CoverImage,
        InsideImage: currentPreview.SelectedCard.InsideImage,
        VerseImage: currentPreview.SelectedVerse.VerseImage,
        ServiceLineSingle: "",
        ServiceLineMultiple: "",
        Intention: currentCart.Intention,
        DateHeader: "",
        MassDate: currentCart.MassDate,
        SignAsLines: currentCart.CardSignature,
        CustomVerse: "",
        Product: config.settings.productCollection
    };
    currentCart.EcardData = ecardData;
    currentCart.EcardProductTitle = currentProduct.EcardProductTitle;
  } 

  if(!currentCart.Id) {
    currentCart.SourceCode = getSourceCode();
  }
  
  // for donations
  // Honoree
  //HonoreeCaption
  
  for(const i in currentCart) {
    cardSendItem.CustomData.push({
      Name: i,
      Value: currentCart[i] 
    });
  }

  let addOrUpdateEndpoint = 'api/requests/AddItem';
  if(cardSendItem.Id) {
    addOrUpdateEndpoint = 'api/requests/UpdateItem';
  }

  return async (dispatch) => {
    const sendRequest = async () => {
      const csrfToken = getCsrfToken();
      const response = await fetch(
        config.settings.apiEndpoint + addOrUpdateEndpoint,
        {
          method: 'POST',
          body: JSON.stringify(cardSendItem),
          credentials: "include",
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': window.AntiForgeryToken
          }
        }
      );

      if (!response.ok) {
        throw new Error('Sending cart data failed.');
      }

      const data = await response.json();

      if(addOrUpdateEndpoint.indexOf('AddItem') > -1) {
        const cartItemElement = document.querySelector('.cartlink span');
        if(cartItemElement) {
          let cartItemCount = Number(cartItemElement.textContent);
          cartItemCount++;
          cartItemElement.textContent = cartItemCount;
        } else {
          const span = document.createElement("span");
          const node = document.createTextNode("1");
          span.appendChild(node);
          const cartLink = document.querySelector('.cartlink');
          if(cartLink) {
            cartLink.appendChild(span);
          }
        }
      }

      return data;
    };

    try {

      const cartItemData = await sendRequest();
      dispatch(configuratorActions.setApprove(cartItemData.Id));

    } catch (error) {
      console.log(error);
    }
  };
};